import validate from "/home/forge/shop.ullmax.com/releases/81023597/node_modules/nuxt/dist/pages/runtime/validate.js";
import getseller_45global from "/home/forge/shop.ullmax.com/releases/81023597/middleware/getseller.global.ts";
import manifest_45route_45rule from "/home/forge/shop.ullmax.com/releases/81023597/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  getseller_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}